import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import { navigateToUrl } from '../../../utilities/StringHelpers/StringHelpers';

const SelfCareFamilyMemberDiscountPackageMain = (props) => {

  const title = props.iContent.title?.value;
  const packageSize = props.iContent.packageSize?.value;
  const packagePrice = props.iContent.packagePrice?.value;
  const buttonText = props.iContent.buttonText?.value;
  const buttonUrl = props.iContent.buttonUrl?.value?.url;

  return (
    <div className='selfcare-family-member-discount-package'>
      <div className='titles-wrapper'>
        <span className='title'>{title}</span>
        <span className='package-size-and-price-line'>
          {packageSize} ב-<span className='package-price'>{packagePrice}</span> ש"ח
        </span>
      </div>
      <BtnSubmit text={buttonText} onClick={() => navigateToUrl(buttonUrl)} />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(SelfCareFamilyMemberDiscountPackageMain);
